import React, { SyntheticEvent, useEffect, useRef, useState } from "react";
import DesignerMain from "./DesignerMain";
import { Box } from "@mui/material";
import { Autocomplete, TextField } from "@mui/material";
import { StyleSettings } from "src/styles/StyleSettings";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { fnGetDataSet } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import axios from "axios";
import FreeForm from "@widgets/FreeForm";

export type DesignerProps = {
  headerRight?: React.ReactNode;
  extraPanel?: React.ReactNode;
  previewLoadData?: any;
};

export default function Drawing({
  headerRight,
  extraPanel,
  previewLoadData,
}: DesignerProps) {
  const [open, setOpen] = useState(false);
  const fontSize = StyleSettings.font;
  const MenusidebarRef = useRef<any>(null);
  const mainRef = useRef<any>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [inputValue, setInputValue] = useState<string>("");
  const [options, setOptions] = useState<any[]>([]);
  const [loadData, setLoadData] = useState<any>();
  const [noIssue, setnoIssue] = useState<string | null>(null);
  const [cdmenu, setCdmenu] = useState<string | null>(null);
  const hasPreviewDataRef = useRef(false);
  const { userInfo } = global();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const no_issue = params.get("noissue") || "";
    const fetchOptions = async () => {
      const search = {
        queryId: "intiDesign",
        id: "DesignerMapper",
        params: {
          no_issue: no_issue,
        },
      };
      const data: any = await fnGetDataSet(search);
      setOptions(data[0]);

      setnoIssue(params.get("noissue"));
      setCdmenu(params.get("cdmenu"));
      const rtn2 = data[1];

      // 초기 로딩 시 DB에 저장된 js_setting을 적용.
      // 단, MCP 프리뷰 결과가 먼저 들어온 경우(hasPreviewDataRef)
      // 기존 저장 데이터로 덮어쓰지 않도록 방지.

      if (rtn2.length > 0 && !hasPreviewDataRef.current) {
        setLoadData(JSON.parse(rtn2[0].js_setting));
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    if (previewLoadData) {
      hasPreviewDataRef.current = true;
      setLoadData(previewLoadData);
    }
  }, [previewLoadData]);

  const [selectedOption, setSelectedOption] = useState<any | null>(null);

  const handleChange = (e: SyntheticEvent, value: any) => {
    loadform(value);
    setSelectedOption(value);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLDivElement> & {
      defaultMuiPrevented?: boolean;
    }
  ) => {
    if (e.key === "Enter") {
      const currentValue = inputRef.current?.value;
      // currentValue와 options에서 nm_path가 포함되는 항목을 필터링
      const filtered = options.filter(
        (option) =>
          currentValue &&
          (option.nm_menu.trim() === currentValue.trim() ||
            option.cd_menu.trim() === currentValue.trim())
      );
      if (filtered.length === 1) {
        const value = filtered[0];
        loadform(value);
        setSelectedOption(value);
      }
    }
  };
  const loadform = async (params: any) => {
    try {
      const rtn: any = await getInitFormData({
        cd_menu: params.cd_menu,
        cd_moudule: params.cd_module,
      });
      setLoadData({
        formControlData: rtn.formControlData,
        formData: rtn.formData,
        columns: rtn.grid,
        formControls: rtn.form,
      });
      setInputValue("");
    } catch (error) {}
  };

  const handleInputChange = (
    e: SyntheticEvent,
    value: string,
    reason: string
  ) => {
    switch (reason) {
      case "input":
        setInputValue(value);
        break;
      case "clear":
        setInputValue("");
        break;
    }
  };

  /**
   * x 버튼 클릭 시 동작할 메서드
   */
  const handleClear = () => {
    setInputValue("");
  };

  const downLoadLayout = () => {
    mainRef.current?.downLoadLayout();
  };

  const downLoadFront = () => {
    mainRef.current?.downLoadFront();
  };

  const downLoadBack = () => {
    mainRef.current?.downLoadBack();
  };

  // start 하기 전의 이슈만 저장 가능
  // 저장이 꼭 필요하면 업무서버 db에서 이슈 상태를 잠깐 바꿔서 저장해주세요
  const save = async () => {
    // 이슈 상태 체크
    const param = {
      id: "com_designer_01",
      params: {
        no_issue: noIssue,
      },
    };
    const data = await fnGetDataSet(param);
    if (data[0] && data[0].length > 0) {
      const st_issue = data[0][0].st_issue;
      if (st_issue === "0" || st_issue === "1" || st_issue === "2") {
        mainRef.current?.save();
      } else {
        await showDialog(
          "alter",
          "이미 진행된 이슈입니다. 이슈 상태를 확인해주세요."
        );
      }
    } else {
      await showDialog("alter", "이슈번호가 없습니다.");
    }
  };

  const deploydev = async () => {
    mainRef.current?.deploydev();
  };
  // 개발서버 배포 시, sfa_issue_design 테이블을 기준으로 배포
  const deploy = async () => {
    // 1. 개발서버 sys_mmenu의 메뉴코드 확인 → 없으면 배포 X
    try {
      mainRef.current?.deploy();
    } catch (error) {
      console.error("API 호출 실패1", error);
      await showDialog("error", "개발서버와의 통신 실패");
      return;
    }
  };

  const effectiveLoadData = previewLoadData ?? loadData;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        // overflowX: "auto",
      }}
    >
      <div className="min-h-screen bg-gray-100">
        {/* 상단 헤더 */}
        <div className="flex items-center justify-between bg-blue-600 px-4 h-14 shadow-md">
          {/* 햄버거 메뉴 */}
          <div
            className="flex flex-col justify-center cursor-pointer w-6 h-6"
            onClick={() => setOpen(!open)}
          >
            <span className="h-0.5 bg-white mb-1"></span>
            <span className="h-0.5 bg-white mb-1"></span>
            <span className="h-0.5 bg-white"></span>
          </div>

          {/* 검색창 */}
          <div className="w-[300px] mr-2">
            <Autocomplete
              value={selectedOption}
              selectOnFocus={false}
              disableClearable={false}
              blurOnSelect
              options={options}
              isOptionEqualToValue={() => false}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              getOptionLabel={(option) => `[${option.cd_menu}]`}
              filterOptions={(options, state) => {
                if (!state.inputValue.trim()) {
                  return [];
                }
                return options.filter(
                  (option) =>
                    option.cd_menu.includes(state.inputValue) ||
                    option.nm_menu.includes(state.inputValue)
                );
              }}
              inputValue={inputValue}
              onInputChange={handleInputChange}
              slotProps={{
                popper: {
                  style: { width: "480px" },
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [90, 4], // (450 - 300) / 2 = 75, 오른쪽으로 75px 당기기
                      },
                    },
                  ],
                },
              }}
              renderOption={(props, option) => {
                return (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      fontSize: fontSize,
                      //fontFamily: "monospace", // 정렬 잘 되도록
                    }}
                  >
                    <span style={{ width: "230px", flexShrink: 0 }}>
                      {option.cd_menu}
                    </span>
                    <span>: {option.nm_menu}</span>
                  </li>
                );
              }}
              renderInput={(params) => (
                <div className="h-8">
                  <TextField
                    {...params}
                    inputRef={inputRef}
                    placeholder="검색"
                    className="h-full w-full"
                    sx={{
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: "999px", // ✅ 외부 div에 둥글게
                      "& .MuiInputBase-root": {
                        height: "100%",
                        borderRadius: "999px", // ✅ 내부 input도 둥글게
                        fontSize: fontSize,
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "gray.400",
                        borderRadius: "999px", // ✅ 테두리도 둥글게
                      },
                      "& .MuiInputBase-input": {
                        height: "100%",
                        padding: "0 12px",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                </div>
              )}
              forcePopupIcon={false}
            />
          </div>
          {/* 다운로드 버튼 */}
          <div className="flex flex-row items-center gap-2">
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={save}
            >
              <span className="text-sm font-medium">저장</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={deploydev}
            >
              <span className="text-sm font-medium">개발서버배포</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={deploy}
            >
              <span className="text-sm font-medium">배포</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={downLoadLayout}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                />
              </svg>
              <span className="text-sm font-medium">Layout</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={downLoadFront}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                />
              </svg>
              <span className="text-sm font-medium">Front</span>
            </button>
            <button
              className="flex items-center gap-2 bg-white text-blue-600 px-3 py-1.5 rounded-md shadow hover:bg-blue-50 transition"
              onClick={downLoadBack}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                />
              </svg>
              <span className="text-sm font-medium">Back</span>
            </button>
            {headerRight}
          </div>
        </div>

        {/* 사이드바 */}
        {extraPanel}

        <DesignerMain
          loadData={effectiveLoadData}
          menuOptions={selectedOption}
          ref={mainRef}
          cdMenu={cdmenu || ""}
          noIssue={noIssue || ""}
        />
      </div>
    </Box>
  );
}
